'use strict';

import { stepForward, stepBackward } from '../util/navigation';

const btnBack = document.querySelector('.js-btn-back');

/**
 * @public toggleBackButton
 */
function toggleBackButton() {
    // If it's not the first step, show the back button in the header
    if (this.targetStepIndex.toLowerCase() === this.startStepIndex) {
        this.btnBack.classList.add(this.CONST.classes.hidden);
    } else if (this.targetStepIndex.toLowerCase() === this.firstStepIndex) {
        this.btnBack.classList.add(this.CONST.classes.hidden);
    } else {
        this.btnBack.classList.remove(this.CONST.classes.hidden);
    }
}

/**
 * @public updateBackButtonLabel
 *
 * @description
 * Will update the text for the button
 */
function updateBackButtonLabel() {
    const currentState = window.history.state;

    if (!currentState || (!currentState.stepIndex && !currentState.statementId)) {
        return;
    }

    const indexFromHistory = currentState.stepIndex ? currentState.stepIndex : currentState.statementId;
    const indexInStepsOrder = this.stepsOrder.indexOf(indexFromHistory);
    const selectorAttribute = currentState.stepIndex ? this.attributes.stepIndex : this.attributes.statementId;
    const nameAttribute = currentState.stepIndex ? this.attributes.stepName : this.attributes.statementName;

    let prevStepIndex = this.stepsOrder[indexInStepsOrder - 1];
    if (!prevStepIndex) {
        return;
    }

    prevStepIndex = prevStepIndex.split('__')[0];
    let prevStep = document.querySelector(`[${selectorAttribute}="${prevStepIndex}"]`);
    let prevStepName = prevStep && prevStep.getAttribute(nameAttribute);

    if (!prevStepName && currentState.stepIndex) {
        // This is necessary in case you go from statement > step
        prevStep = document.querySelector(`[${this.attributes.statementId}="${prevStepIndex}"]`);
        prevStepName = prevStep && prevStep.getAttribute(this.attributes.statementName);
    } else if (!prevStepName && currentState.statementId) {
        // This is necessary in case you go from step > statement
        prevStep = document.querySelector(`[${this.attributes.stepIndex}="${prevStepIndex}"]`);
        prevStepName = prevStep && prevStep.getAttribute(this.attributes.stepName);
    }

    if (prevStepName) {
        btnBack.innerText = prevStepName;
    }
}

/**
 * @function updateBackButtonTarget
 */
function updateBackButtonTarget() {
    let backButtonId;

    // Will update the target for the button
    if (this.goingBack) {
        backButtonId = stepBackward.call(this);

        // If we're coming from the thank you page, take an extra step back in order to land back on the advice overview screen
        if (this.currentStepId === this.CONST.bscanSteps.THANKYOU) {
            backButtonId = stepBackward.call(this);
        }
    } else {
        this.currentStepIndex = this.currentStep.getAttribute(this.attributes.stepIndex);
        backButtonId = stepForward(this.currentStepIndex);
    }

    btnBack.setAttribute(this.attributes.targetStep, backButtonId);

    // Will update the text for the back button
    updateBackButtonLabel.call(this);
}

export { toggleBackButton, updateBackButtonTarget, updateBackButtonLabel };
